import { render, staticRenderFns } from "./EditTable.vue?vue&type=template&id=5f479631"
import script from "./EditTable.vue?vue&type=script&lang=js"
export * from "./EditTable.vue?vue&type=script&lang=js"
import style0 from "./EditTable.vue?vue&type=style&index=0&id=5f479631&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports